import {
  type HomepageEntryVariant,
  withHomepageEntryVariant,
} from "@/lib/homepage-entry-experiment";

const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isLandingJobId = (value: string | null | undefined): value is string =>
  !!value && uuidPattern.test(value);

export const getLandingSignupHref = (
  jobId: string,
  homepageEntryVariant?: HomepageEntryVariant
) => {
  const claimPath = `/app/dashboard?landingJobId=${encodeURIComponent(jobId)}`;
  return withHomepageEntryVariant(
    `/app/auth/sign-up?toPath=${encodeURIComponent(claimPath)}`,
    homepageEntryVariant
  );
};
